import React from "react";
import PropTypes from "prop-types";
import mobileStyle from "../../stylesheets/MobileFilter.module.scss";
import style from "../../stylesheets/StoreFilter.module.scss";
import { COLOR_FACET_ID, CATEGORY_FACET_ID } from "../../constants";

function StoreFilter(props) {
  const {
    facetFilter,
    selectedDropdown,
    showDropdown,
    children,
    isMobile,
    selectedFilters = [],
  } = props;

  if (facetFilter.active_facet_tags.length === 0) {
    return null;
  }

  const handleClickDropdown = () => {
    showDropdown(facetFilter.facet.id);
  };

  const selectedDropdownClass =
    selectedDropdown === facetFilter.facet.id ? style.selectedDropdown : "";

  const nonColorMultiSelect =
    selectedDropdown === facetFilter.facet.id &&
    selectedDropdown !== CATEGORY_FACET_ID &&
    selectedDropdown !== COLOR_FACET_ID;

  const selectedNonColorMultiSelectDropdown = nonColorMultiSelect
    ? "selectedNonColorMultiSelectDropdown"
    : "";

  const selectedNonColorMultiSelectTitle = nonColorMultiSelect
    ? "selectedNonColorMultiSelectTitle"
    : "";

  const selectedDropdownIcon =
    selectedDropdown === facetFilter.facet.id ? "Up" : "Down";

  const colorFilterDropdown =
    facetFilter.facet.id === COLOR_FACET_ID ? style.colorFilterDropdown : "";
  const mobileColorFilterDropdown =
    facetFilter.facet.id === COLOR_FACET_ID
      ? mobileStyle.colorFilterDropdown
      : "";
  const categoryFilterDropdown =
    facetFilter.facet.id === CATEGORY_FACET_ID
      ? style.categoryFilterDropdown
      : "";

  const selectedFiltersName =
    selectedFilters.length === 0
      ? "All"
      : selectedFilters.map((selectedFilter, i) => {
          const comma = i === selectedFilters.length - 1 ? "" : ", ";
          return (
            <span>
              {selectedFilter.name}
              {comma}
            </span>
          );
        });

  return isMobile ? (
    <div className={mobileStyle.filterWrapper}>
      {facetFilter.facet.display_name}
      <div
        className={mobileStyle.filterTitle}
        onClick={handleClickDropdown}
        tabIndex="0"
      >
        <span className={mobileStyle.selectedFilters}>
          {selectedFiltersName}
        </span>
        <img
          className={style.dropdownIcon}
          src={`https://cdn-s3.touchofmodern.com/images/icons/icon_filter${selectedDropdownIcon}Arrow%402x.png`}
          alt="filterArrow"
        />
      </div>
      <div
        className={`${mobileStyle.filterDropdown} ${mobileColorFilterDropdown} ${selectedDropdownClass}`}
      >
        {children}
      </div>
    </div>
  ) : (
    <div
      className={`${style.filterWrapper} ${categoryFilterDropdown}`}
      tabIndex="0"
    >
      <div
        className={`${style.filterTitle} ${selectedNonColorMultiSelectTitle}`}
        onClick={handleClickDropdown}
      >
        {facetFilter.facet.display_name}
        <img
          className={style.dropdownIcon}
          src={`https://cdn-s3.touchofmodern.com/images/icons/icon_filter${selectedDropdownIcon}Arrow%402x.png`}
          alt="filterArrow"
        />
      </div>
      <div
        className={`${style.filterDropdown} ${colorFilterDropdown} ${selectedDropdownClass} ${selectedNonColorMultiSelectDropdown}`}
      >
        {children}
      </div>
    </div>
  );
}

StoreFilter.propTypes = {
  facetFilter: PropTypes.object.isRequired,
  selectedDropdown: PropTypes.number.isRequired,
  showDropdown: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default StoreFilter;
